<template>
    <div class="miniMatchCardClose miniMatchCard">
        <div class="miniMatchCard_teamInfo">
            <div class="miniMatchCard_teams">
                <div class="miniMatchCard_teamRow">
                    <div class="miniMatchCard_teamNameContainer">
                        <picture>
                            <source
                                v-bind:srcset="`${homeTeamLogo.webp}`"
                                type="image/webp"
                            />
                            <img
                                v-bind:src="`${homeTeamLogo.origin}`"
                                alt="home team flag"
                                class="miniMatchCard_flag"
                            />
                        </picture>
                        <div class="miniMatchCard_teamName">
                            {{ homeTeam }}
                        </div>
                    </div>
                </div>
                <div class="miniMatchCard_teamRow">
                    <div class="miniMatchCard_teamNameContainer">
                        <picture>
                            <source
                                v-bind:srcset="`${awayTeamLogo.webp}`"
                                type="image/webp"
                            />
                            <img
                                v-bind:src="`${awayTeamLogo.origin}`"
                                alt="away team flag"
                                class="miniMatchCard_flag"
                            />
                        </picture>
                        <div class="miniMatchCard_teamName">
                            {{ awayTeam }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="miniMatchCard_oddsInfo">
            <div class="miniMatchCard_marketLabel">
                {{ fullTimeHandicapText }}
            </div>
            <div class="miniMatchCard_odds" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, toRefs } from 'vue';
    import { getTournamentCenterTeamImage } from '@/components/tournamentCenter/tournamentCenterHelper';
    import { i18n } from '@/core/lib/i18n';
    import { getTranslated } from '@/core/lib/translationHelper';
    import type { IKnockoutEvent } from '@/interface/tournamentCenter';

    const props = defineProps<{
        event: IKnockoutEvent;
    }>();

    const { event } = toRefs(props);
    const homeTeam = computed(() => (event.value.homeTeam ? getTranslated(event.value.homeTeam?.teamName) : 'TBD'));
    const awayTeam = computed(() => (event.value.awayTeam ? getTranslated(event.value.awayTeam?.teamName) : 'TBD'));

    const homeTeamLogo = computed(() => getTournamentCenterTeamImage(event.value.homeTeam?.countryName));
    const awayTeamLogo = computed(() => getTournamentCenterTeamImage(event.value.awayTeam?.countryName));

    const fullTimeHandicapText = computed(() => i18n.t('full_time_handicap_short'));
</script>

<style lang="scss" scoped>
    @import "@/components/tournamentCenter/MiniMatchCard";
</style>
